export default {
    cn: {
        mt4CreditReport: {
            timeText: '交易时间：',
            downloadName: 'MT4信用额报表',
            loadText: '正在下载,请稍候...',
            tableHead: [
                { key: 'TICKET', value: '交易单号' },
                { key: 'LOGIN', value: '账号' },
                { key: 'NAME', value: '姓名' },
                { key: 'CURRENCY', value: '入金货币' },
                { key: 'IB_ID', value: '代理账号' },
                { key: 'OFFICE_NAME', value: '所属办事处' },
                { key: 'OID', value: '办事处号码' },
                { key: 'ACC_NAME', value: '所属地区' },
                { key: 'RID', value: '地区编号' },
                { key: 'GROUP', value: '组别' },
                { key: 'CLOSE_TIME', value: '交易时间' },
                { key: 'VALUE_TIME', value: '交易日期' },
                { key: 'COMMENT', value: '注释' },
                { key: 'PROFIT', value: '金额' }
            ]
        }
    },
    hk: {
        mt4CreditReport: {
            timeText: '交易時間：',
            downloadName: 'MT4信用額報表',
            loadText: '正在下載,請稍候...',
            tableHead: [
                { key: 'TICKET', value: '交易單號' },
                { key: 'LOGIN', value: '賬號' },
                { key: 'NAME', value: '姓名' },
                { key: 'CURRENCY', value: '入金貨幣' },
                { key: 'IB_ID', value: '代理賬號' },
                { key: 'OFFICE_NAME', value: '所屬辦事處' },
                { key: 'OID', value: '辦事處號碼' },
                { key: 'ACC_NAME', value: '所屬地區' },
                { key: 'RID', value: '地區編號' },
                { key: 'GROUP', value: '組別' },
                { key: 'CLOSE_TIME', value: '交易時間' },
                { key: 'Value_TIME', value: '交易日期' },
                { key: 'COMMENT', value: '注釋' },
                { key: 'PROFIT', value: '金額' },
            ]
        }
    },
    en: {
        mt4CreditReport: {
            timeText: 'Trade Time：',
            downloadName: 'MT4 Credit Report',
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [
                { key: 'TICKET', value: 'Deal' },
                { key: 'LOGIN', value: 'Login' },
                { key: 'NAME', value: 'Name' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'IB_ID', value: 'IB Account' },
                { key: 'OFFICE_NAME', value: 'Office Name' },
                { key: 'OID', value: 'Office ID' },
                { key: 'ACC_NAME', value: 'Region Name' },
                { key: 'RID', value: 'Region ID' },
                { key: 'GROUP', value: 'Group' },
                { key: 'CLOSE_TIME', value: 'Date' },
                { key: 'Value_TIME', value: 'Value Date' },
                { key: 'COMMENT', value: 'Comment' },
                { key: 'PROFIT', value: 'Amount' },
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/manager-report/mt4CreditReport.js